import React, { useState, useEffect } from 'react';
import ChallengeDialog from "../../common/components/ChallengeDialog";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Button, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import Layout from '../../common/Layout';
import CareerHeader from '../../common/components/CareerHeader/CareerHeader';
import CareerDetails from '../../common/components/CareerDetails/CareerDetails';
import CareerInfos from '../../common/components/CareerInfos/CareerInfos';
import CareerLearningTopics from '../../common/components/CareerLearningTopics/CareerLearningTopics';
import SubHeader from '../../common/components/SubHeader/SubHeader';
import useAppStore from '../../store/appStore';
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import { useCarrerBySlug } from '../../hooks/useCareerBySlug';
import { useCareerLearningTopicsBySlug } from '../../hooks/useCareerLearningTopicsBySlug';
import { useChallenge } from '../../hooks/useChallenge';
import { useStartChallenge } from '../../hooks/useStartChallenge'; // Nuovo import


const useStyles = makeStyles((theme) => ({
  gridRoot: {
    marginBottom: 32,
  },
  ctaBox: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "flex-end",
    alignItems: "flex-end",
    height: "100%",
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: "center",
      alignItems: "flex-end",
      textAlign: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: "flex-start",
    },
  },
  ctaText: {
    marginRight: 6,
    color: theme.palette.text.secondary,
    marginBottom: 4,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: 4,
    },
  },
  ctaBtn: {
    width: 165,
    backgroundColor: theme.palette.common.gamsDarkBlue,
    color: theme.palette.common.white,
    lineHeight: 1.2,
    '&:hover': {
      backgroundColor: theme.palette.common.gamsPetroleumBlue,
      color: theme.palette.common.white,
    },
    '&:focus': {
      outline: 'none',
      color: theme.palette.common.white,
    },
  },
  defaultDialogIcon: {
    fontSize: theme.typography.pxToRem(32),
    color: theme.palette.warning.main,
  },
  defaultDialogTextBox: {
    maxWidth: 440,
    margin: '0 auto',
    paddingTop: 12,
    paddingBottom: 8,
    textAlign: 'center',
    '& h1': {
      fontSize: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium,
      marginBottom: 30,
    },
    '& p': {
      textAlign: 'left',
      marginBottom: 12,
    }
  },
}));

const CareerSingle = props => {
  const classes = useStyles();
  const [careerProgress, setCareerProgress] = useState(0);
  const user = useAppStore((state) => state.user);
  const [isStartingChallenge, setIsStartingChallenge] = useState(false); // Nuovo state per loading
  const [state, setState] = useState({
    challengesToDo: [],
    selectedChallengeDescription: "",
    selectedChallengeCoachId: null,
    selectedChallengeType: "",
    selectedChallengeTopic: "",
    selectedChallengeInitialLocation: "",
    selectedChallengeTitle: null,
    selectedChallengeIsValidation: null,
    selectedChallengeDifficulty: null,
    selectedChallengeAverageTime: null,
    selectedChallengeCoachName: "",
    selectedChallengeCoachSurname: "",
    selectedChallengeCoachAvatar: "",
    selectedChallengeCoachLink: "",
    open: false
  });

  const [selectedId, setSelectedId] = useState(null);
  const [restart, setRestart] = useState(false);
  const [inProgress, setInProgress] = useState(false); // Nuovo state per inProgress
  const [openTrigger, setOpenTrigger] = useState(0); // Trigger per forzare apertura
  const { isFetching: isCareerFetching, error, data: dataCarrer } = useCarrerBySlug(props.match.params.slug);
  const { isFetching: isCareerLearningTopicsFetching, error: errorLearningTopics, data: dataCareerLearningTopics } = useCareerLearningTopicsBySlug(props.match.params.slug);
  const { data: selectedChallenge, isPending: isChallengeLoading, error: isChallengeError } = useChallenge(selectedId);
  
  // Nuovo hook per startare la challenge
  const startChallengeMutation = useStartChallenge();

  const isTrial = user?.me ? user?.me.userType === 'b2c-trial' : null;

  const handleOpen = (id, restartFlag = false, name, surname, avatar, link, inProgressFlag = false) => {
    setSelectedId(id);
    setRestart(restartFlag);
    setInProgress(inProgressFlag); // Salva il flag inProgress
    setState( prev => ({
        ...prev,
        selectedChallengeCoachName: name,
        selectedChallengeCoachSurname: surname,
        selectedChallengeCoachAvatar: avatar,
        selectedChallengeCoachLink: link,
    }));
    // Incrementa il trigger per forzare l'useEffect
    setOpenTrigger(prev => prev + 1);
  };

  useEffect(() => {
    // Apri solo se selectedChallenge è caricato, non in loading e openTrigger > 0
    if (selectedChallenge && selectedId !== null && !isChallengeLoading && openTrigger > 0) {
      const selectedChallengeDescription = selectedChallenge.challengeDefinition?.challengeDescription;
      const selectedChallengeCoachId = selectedChallenge.challengeDefinition?.coach;
      const selectedChallengeTitle = selectedChallenge.challengeDefinition?.challengeTitle;
      const selectedChallengeIsValidation = selectedChallenge.challengeDefinition?.isValidation;
      const selectedChallengeDifficulty = selectedChallenge.challengeDefinition?.challengeDifficulty;
      const selectedChallengeAverageTime = selectedChallenge.challengeDefinition?.averageTime;
      const selectedChallengeInitialLocation = selectedChallenge?.challengeDefinition?.steps?.[0]?.initialLocationSimulation;
      const selectedChallengeLearningTopic = selectedChallenge?.challengeDefinition?.learningTopics;

      setState( prev => ({
        ...prev,
        selectedChallengeDescription,
        selectedChallengeInitialLocation,
        selectedChallengeType: selectedId,
        selectedChallengeLearningTopic,
        selectedChallengeCoachId,
        selectedChallengeTitle,
        selectedChallengeIsValidation,
        selectedChallengeDifficulty,
        selectedChallengeAverageTime,
        restart,
        open: true
      }));
    }
  }, [selectedChallenge, selectedId, restart, openTrigger, isChallengeLoading]);

  const [deviceType, setDeviceType] = useState('');
  let device = '';
  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (/mobile|tablet/i.test(userAgent)) {
      setDeviceType('mobile');
      device = 'moblie';
    } else {
      setDeviceType('desktop');
      device = 'desktop';
    }
  }, []);

  const handleClose = () => {
    setState(prev => ({ ...prev, open: false }));
  };

  // Funzione handleSave aggiornata con REST (manteniamo il codice GraphQL commentato)
  async function handleSave() {
    const {
      selectedChallengeType,
      selectedChallengeInitialLocation,
      restart
    } = state;

    setIsStartingChallenge(true);
   
    try {
      // Nuova implementazione REST
      const result = await startChallengeMutation.mutateAsync({
        challengeType: selectedChallengeType,
        restart: restart || false,
        inProgress: inProgress || false  // Aggiungi il parametro inProgress
      });
      const id = result.createChallenge?.challengeInstanceId || result.createChallenge?._id;
      props.setChallengeOrigineRoute(props.location.pathname);
      props.history.push(`${selectedChallengeInitialLocation}/${id}`);
      
    } catch (error) {
      console.error('Error starting challenge:', error);
    } finally {
      setIsStartingChallenge(false);
    }
  }

  useEffect(() => {
  if (dataCarrer && dataCarrer.careerPathBySlug && dataCarrer.careerPathBySlug.totalFinishedChallenges) {
    setCareerProgress((dataCarrer.careerPathBySlug.totalFinishedChallenges / dataCarrer.careerPathBySlug.totalChallenges) * 100)
  }
}, [dataCarrer]);


  return (
    <Layout>
      {( isCareerFetching || !dataCarrer) ? (
        <LoadingSpinner styles={{ paddingTop: 60 }} />
      ) : error ? (
        <div>Error! {error && error.message} </div>
      ) : (
        <>
          {isTrial ?
            <>
              {/*<SubscriptionAlert
                alertTitle={dataCarrer?.careerSinglePage?.data?.attributes?.subscriptionAlert?.title}
                alertSubtitle={dataCarrer?.careerSinglePage?.data?.attributes?.subscriptionAlert?.subTitle}
                alertBtnAction={subscriptionAlertAction}
                alertBtnText={dataCarrer?.careerSinglePage?.data?.attributes?.subscriptionAlert?.textButton}
              />
            <SubscriptionDialog
                dialogClose={handleDialogClose}
                dialogOpen={dialogOpen}
                enablePrice={enablePrice}
                title={globalContent.subscriptionDialog.title}
                subTitle={globalContent.subscriptionDialog.description}
                pricingPlan={globalContent.pricingPlan}
                ctaFaqs={globalContent.subscriptionDialog.ctaFaqs}
              />*/}
            </>
          : null}
          <CareerHeader
            title={dataCarrer?.careerPathBySlug?.name}
            description={dataCarrer?.careerPathBySlug?.description}
            fullImage={dataCarrer?.careerPathBySlug?.cover?.data?.attributes?.url ? dataCarrer?.careerPathBySlug?.cover?.data?.attributes?.url : ''}
            videoLink={dataCarrer?.careerPathBySlug?.videoLink}
          />
          <Grid container spacing={3} className={classes.gridRoot}>
            <Grid item xs={12} md={12} lg={8} xl={8}>
              <CareerDetails
                aboutCareer={dataCarrer?.careerPathBySlug?.aboutCareer?.content}
                keySkills={dataCarrer?.careerPathBySlug?.keySkills?.content}
                toolsUsed={dataCarrer?.careerPathBySlug?.toolsUsed}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={4} xl={4}>
              <CareerInfos
                careerProgress={careerProgress}
                careerObtainableScore={dataCarrer?.careerPathBySlug?.obtainableScore}
                careerScore={dataCarrer?.careerPathBySlug?.score}
                totalFinishedLearningTopics={dataCarrer?.careerPathBySlug?.totalFinishedLearningTopics}
                totalLearningTopics={dataCarrer?.careerPathBySlug?.totalLearningTopics}
                careerTags={dataCarrer?.careerPathBySlug?.tags}
                careerBadges={dataCarrer?.careerPathBySlug?.badges}
              />
            </Grid>
          </Grid>
          <SubHeader
            title={dataCarrer?.careerSinglePage?.data?.attributes?.subPageHeader?.title}
            subTitle={dataCarrer?.careerSinglePage?.data?.attributes?.subPageHeader?.subTitle}
            cta={
              <Box
                className={classes.ctaBox}
                id="learningTopics"
              >
                <Typography
                  className={classes.ctaText}
                  variant="body2"
                  component="div"
                >Check your progress in the</Typography>
                <Button component={RouterLink} className={classes.ctaBtn} to="/psc" target="_blank">
                  Profile Scorecard
                </Button>
              </Box>
            }
          /> {( isCareerLearningTopicsFetching || !dataCareerLearningTopics) ? (
        <LoadingSpinner styles={{ paddingTop: 60 }} />
      ) : error ? (
        <div>Error! {error && error.message} </div>
      ) : (
          <CareerLearningTopics
            careerStartLevel={dataCarrer?.careerPathBySlug?.startLevel}
            careerStatus={dataCarrer?.careerPathBySlug?.status}
            learningTopics={dataCareerLearningTopics?.learningTopics?.learningTopics}
            isCaptain={dataCareerLearningTopics?.learningTopics?.isTeamLeader}
            challengeAction={handleOpen}
          />)}
          <ChallengeDialog
            //title="Start Challenge"
            handleUndo={handleClose}
            handleClose={handleClose}
            handleSave={handleSave}
            open={state.open}
            saveName={isStartingChallenge ? "STARTING..." : "START CHALLENGE"} // Testo dinamico
            button={true}
            coach={state.selectedChallengeCoachId}
            coachName={state.selectedChallengeCoachName}
            coachSurname={state.selectedChallengeCoachSurname}
            coachAvatar={state.selectedChallengeCoachAvatar}
            coachLink={state.selectedChallengeCoachLink}
            challengeDashboard={true}
            brief={state.selectedChallengeDescription}
            challengeTitle={state.selectedChallengeTitle}
            challengeIsValidation={state.selectedChallengeIsValidation}
            challengeDifficulty={state.selectedChallengeDifficulty}
            challengeAverageTime={state.selectedChallengeAverageTime}
            disabled={isStartingChallenge} // Disabilita durante la chiamata
          />
        </>
      )}
    </Layout>
  )
}

export default CareerSingle;
